import "./FlashStyle.css";
import React, { useState, useEffect } from "react";
import TitleOfSection from "../TitleOfSection";
import Card from "../../Card";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useTranslation } from "react-i18next";
import { Keyboard, Pagination, Navigation } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { link } from "../../../config.js";

const ShopBycategoryModification = ({
  id,
  subCategory,
  update_p,
  personal,
  bannersSubCategories,
}) => {
  const [active, setActive] = useState("new");
  const [products, setProducts] = useState([]);
  const [rates, setRates] = useState([]);
  const [subid, setSubid] = useState("");

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const result = bannersSubCategories.find(
    (item) => item.subCategory._id === subid
  );

  useEffect(() => {
    if (subCategory.length > 0) {
      setActive(subCategory[0].name);
      setSubid(subCategory[0]._id);
    }
  }, [subCategory]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const { data } = await axios.get(`${link}product/`);
        const filtered = data.filter(
          (product) => product.subCategory?._id === subid
        );
        setProducts(filtered);
      } catch (error) {
        console.error("Error fetching featured items:", error);
      }
    };

    if (subid) fetchProducts();
  }, [active, subid, id]);

  const handleViewAllClick = () => {
    navigate(`/shopbycategory/${id}/${subid}/1`);
  };

  // FIX: filter first, then pair — was using unfiltered `products` before
  const visibleProducts = products.filter((p) => p.view);
  const productPairs = visibleProducts.reduce((acc, product, index) => {
    if (index % 2 === 0) {
      acc.push(visibleProducts.slice(index, index + 2));
    }
    return acc;
  }, []);

  return (
    <div className="my-5">
      <div className="container mb-2">
        <div className="d-flex justify-content-between align-items-center">
          <TitleOfSection title={t("Shop by sub category")} />
        </div>

        <div className="list-category">
          <ul className="flex-wrap">
            {Array.isArray(subCategory)
              ? subCategory.map((category, index) => (
                  <li
                    key={index}
                    className={`${active === category.name ? "active" : ""}`}
                    onClick={() => {
                      setActive(category.name);
                      setSubid(category._id);
                    }}
                  >
                    {i18n.language === "en" ? category.name : category.nameAr}
                  </li>
                ))
              : null}
          </ul>
        </div>
      </div>

      {/* ── DESKTOP (lg+): side-by-side swiper + banner image ── */}
      <div className="d-none d-lg-flex justify-content-between align-items-stretch side-products">
        <Swiper
          slidesPerView={2}
          spaceBetween={20}
          breakpoints={{
            992: { slidesPerView: 2, spaceBetween: 20 },
            1200: { slidesPerView: 2.4, spaceBetween: 20 },
            1400: { slidesPerView: 3, spaceBetween: 20 },
            1600: { slidesPerView: 3.4, spaceBetween: 30 },
          }}
          navigation={true}
          modules={[Keyboard, Pagination, Navigation]}
          className="mySwiper mx-2 p-4"
          // FIX: use flex-grow instead of hardcoded 70% so it adapts
          style={{ flex: "1 1 0", minWidth: 0 }}
        >
          {productPairs.map((productPair, index) => (
            <SwiperSlide key={index} className="product-slide">
              <div className="product-column">
                {productPair.map((product, subIndex) => (
                  <Card
                    key={subIndex}
                    ImageCard={product?.images[0]?.secure_url}
                    personal={personal}
                    update_p={update_p}
                    brand={product.brand}
                    name={product.name}
                    price={product.price_after}
                    id={product._id}
                    rate={product.averageRating ?? 0}
                    price_after={product.price_after}
                    price_before={product.price_before}
                    product={product}
                  />
                ))}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {result?.image?.secure_url && (
          <img
            src={result.image.secure_url}
            alt={result.image.public_id}
            onClick={() => result?.link && (window.location.href = result.link)}
            style={{ cursor: result?.link ? "pointer" : "default" }}
          />
        )}
      </div>

      {/* ── MOBILE / TABLET (below lg): single-card swiper ── */}
      {/* FIX: use i18n direction instead of hardcoded rtl */}
      <div
        className="d-lg-none"
        style={{ direction: i18n.dir() }}
      >
        <Swiper
          // FIX: correct mobile-first breakpoints (start at 1 slide, scale up)
          slidesPerView={1}
          spaceBetween={10}
          breakpoints={{
            480: { slidesPerView: 1.5, spaceBetween: 15 },
            640: { slidesPerView: 2, spaceBetween: 20 },
            768: { slidesPerView: 2.5, spaceBetween: 20 },
          }}
          // navigation={true}
          modules={[Keyboard, Pagination]}
          className="mySwiper mx-3"
        >
          {visibleProducts.map((product, index) => (
            <SwiperSlide
              key={product._id}
              className="d-flex flex-column justify-content-center gap-3"
            >
              <Card
                ImageCard={product?.images[0]?.secure_url}
                personal={personal}
                update_p={update_p}
                brand={product.brand}
                name={product.name}
                price={product.price_after}
                id={product._id}
                rate={rates[index]}
                price_after={product.price_after}
                price_before={product.price_before}
                product={product}
              />
            </SwiperSlide>
          ))}
        </Swiper>

        {/* FIX: show banner image on mobile too, full width */}
        {result?.image?.secure_url && (
          <div className="container mt-3">
            <img
              src={result.image.secure_url}
              alt={result.image.public_id}
              onClick={() =>
                result?.link && (window.location.href = result.link)
              }
              style={{
                cursor: result?.link ? "pointer" : "default",
                width: "100%",
                borderRadius: "8px",
                objectFit: "cover",
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ShopBycategoryModification;